module.exports = __webpack_public_path__ + "img/GAME_MINHWATU.67a16abb.jpg";